import styled from 'styled-components';

export interface BootstrapButton {
  color?: 'primary' | 'default' | 'secondary' | 'success' | 'info' | 'danger' | 'warning';
  disabled?: boolean;
  block?: boolean;
  size?: 'sm' | 'lg';
  ariaLabel?: string;
}

/**
 * NOTE: Don't use this button in your applications.
 * If you need a button, use `<Button />` from https://reactstrap.github.io/components/buttons/
 */

export const BootstrapButton = styled.button.attrs((props: BootstrapButton) => {
  const buttonClasses = ['btn', 'd-flex', 'align-items-center', `btn-${props.color}`];
  if (props.size) buttonClasses.push(`btn-${props.size}`);
  if (props.block) buttonClasses.push('btn-block justify-content-center');
  return {
  className: buttonClasses.join(' '),
  'aria-label': props.ariaLabel,
  disabled: props.disabled,
}})<BootstrapButton>``;


BootstrapButton.defaultProps = {
  color: 'primary',
  ariaLabel: 'close',
};